/** 職員一覧検索条件 */
export interface StaffSearchCondition {
  /** キーワード:職員名(全角)・ID(半角) */
  keyword: string;
  /** 事業所ID */
  officeId: number;
  /** 状態:在職 */
  status_zai: number;
  /** 状態:休職 */
  status_kyu: number;
  /** 状態:退職 */
  status_tai: number;
  /** グループ:通常グループ */
  groupIds: number[];
  /** グループ:コロナワクチン接種状況 */
  covid19VaccineStatus: number;
  /** グループ:AND/OR検索 0:AND検索 1:OR検索 */
  groupCondition: number;
  /** ソート種類 */
  orderby: number;
  /** ソート順 */
  orderbyType: number;
}

/** 職員一覧検索条件デフォルト値 */
export const DefaultStaffSearchCondition = (): StaffSearchCondition => ({
  keyword: "",
  officeId: 0,
  status_zai: 1,
  status_kyu: 0,
  status_tai: 0,
  groupIds: [0, 0, 0, 0, 0],
  covid19VaccineStatus: 0,
  groupCondition: 1,
  orderby: 1,
  orderbyType: 1
});
